<ng-template #tpl>
	<ng-container *transloco="let translate">
		<div class="text-center">
			<div class="my-1 w-full">
				<img class="h-15" src="assets/images/core/warning.svg" />
				<div class="mt-1 text-xs text-warn">
					@if (!!$quotaNodes()) {
						<span>
							{{ $quotaNodes()?.used || 0 | fileSize: fileSizeConfig }}/{{
								$quotaNodes()?.total || 0 | fileSize: fileSizeConfig
							}}
						</span>
					}

					@if (!$quotaNodes()) {
						<span> &nbsp; </span>
					}
				</div>
			</div>

			<p class="text-icon font-bold text-center">
				{{ translate('errorModals.storage_quota.title') }}
			</p>

			<p class="my-3">
				{{ translate('errorModals.storage_quota.description') }}
			</p>

			<button
				class="py-1.25 px-3 w-full fc-white bg-primary font-bold box-border rounded-1"
				(click)="confirm()"
			>
				{{ translate('errorModals.quota_common.check') }}
			</button>

			<button class="py-1.25 px-3 mt-1 w-full fc-400 box-border" (click)="cancel()">
				{{ translate('general.cancel') }}
			</button>
		</div>
	</ng-container>
</ng-template>
